import { c as _c } from "react/compiler-runtime";
import "@google/model-viewer";
import { useEffect, useMemo, useRef } from "react";
import type { SyntheticEvent } from "react";
import type { BaseNFT } from "@/entities/INFT";
import { getResolvedAnimationSrc } from "./utils/animation-source";
import { withArweaveFallback } from "./utils/gateway-fallback";
type ModelViewerElement = HTMLElement & {
  src: string;
};
export default function NFTModel(props) {
  const $ = _c(10);
  const modelRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = withArweaveFallback();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleArweaveError = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const modelElement = modelRef.current;
      if (!modelElement) {
        return;
      }
      const nativeErrorHandler = event => {
        const currentTarget = event.currentTarget as ModelViewerElement | null;
        if (!currentTarget) {
          return;
        }
        handleArweaveError({
          currentTarget
        } as SyntheticEvent<ModelViewerElement, Event>);
      };
      modelElement.addEventListener("error", nativeErrorHandler);
      return () => {
        modelElement.removeEventListener("error", nativeErrorHandler);
      };
    };
    t2 = [handleArweaveError];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = props.id ?? `iframe-${props.nft.id}`;
  let t4;
  if ($[3] !== props.nft) {
    t4 = getResolvedAnimationSrc(props.nft);
    $[3] = props.nft;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props.nft.name || $[6] !== props.nft.scaled || $[7] !== t3 || $[8] !== t4) {
    t5 = <model-viewer ref={modelRef} id={t3} src={t4} alt={props.nft.name} auto-rotate={true} camera-controls={true} ar={true} poster={props.nft.scaled} />;
    $[5] = props.nft.name;
    $[6] = props.nft.scaled;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}